<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-user"></i>
                </div>
                <div class="header-text">
                    <h2>用户管理</h2>
                    <p>系统用户账号 · 权限分配管理</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.auName" placeholder="搜索姓名" clearable size="medium" class="ai-input"
                            @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <div class="header-search" style="margin-left: 12px;">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.auAccount" placeholder="搜索账号" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增用户
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card - Full Width -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        用户列表
                    </span>
                    <div class="card-actions">
                        <el-select v-model="formDatas.auCheckLeave" placeholder="校验在职" @change="partserch" clearable size="mini" style="width: 90px; margin-right: 8px;">
                            <el-option label="否" :value="1"></el-option>
                            <el-option label="是" :value="2"></el-option>
                        </el-select>
                        <el-select v-model="formDatas.auCheckStatus" placeholder="审核状态" @change="partserch" clearable size="mini" style="width: 90px; margin-right: 12px;">
                            <el-option label="未审核" :value="1"></el-option>
                            <el-option label="在职" :value="2"></el-option>
                            <el-option label="离职" :value="3"></el-option>
                        </el-select>
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            支持账号管理
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage" :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="auId" stripe
                        @page-change="handlePageChange" @operate-btn-click="handleOperateBtnClick"
                        @selection-change="handleSelectionChange">
                        <!-- 自定义单元格插槽 -->
                        <template #cell-auHeader="{ row }">
                            <el-image v-if="row.auHeader" style="width: 40px; height: 40px; border-radius: 8px;"
                                :src="row.auHeader"></el-image>
                            <span v-else class="no-avatar">-</span>
                        </template>
                        <template #cell-auCheckLeave="{ row }">
                            <el-tag :type="row.auCheckLeave == 1 ? 'info' : 'success'" size="small">
                                {{ row.auCheckLeave == 1 ? '否' : row.auCheckLeave == 2 ? '是' : '-' }}
                            </el-tag>
                        </template>
                        <template #cell-auCheckStatus="{ row }">
                            <el-tag :type="row.auCheckStatus == 1 ? 'warning' : row.auCheckStatus == 2 ? 'success' : 'danger'" size="small">
                                {{ row.auCheckStatus == 1 ? '未审核' : row.auCheckStatus == 2 ? '在职' : row.auCheckStatus == 3 ? '离职' : '-' }}
                            </el-tag>
                        </template>
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_user" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增用户信息" dialogWidth="700px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val" @cancel="handleAddCancel"
            @item-change="handleItemChange">
        </aj-form-add>
        <aj-form-edit ref="edit_user" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑用户信息" labelWidth="100px"
            @confirm="handleEditConfirm" @cancel="handleEditCancel" dialogWidth="700px">
        </aj-form-edit>

        <!-- 重置密码弹窗 -->
        <el-dialog title="重置用户密码" :visible.sync="resetPwdDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="resetPwdForm" label-width="80px">
                <el-form-item label="新密码">
                    <el-input v-model="resetPwdForm.auPw" type="password" placeholder="请输入新密码" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetPwdDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleResetPwdConfirm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 离职校验弹窗 -->
        <el-dialog title="离职校验" :visible.sync="checkLeaveDialogVisible" width="450px" :close-on-click-modal="false">
            <el-form :model="checkLeaveForm" label-width="120px">
                <el-form-item label="是否校验花名册在职">
                    <el-radio-group v-model="checkLeaveForm.auCheckLeave">
                        <el-radio :label="1">否</el-radio>
                        <el-radio :label="2">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="checkLeaveForm.auCheckIdcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkLeaveDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleCheckLeaveConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getAjUserList, addAjUser, updateAjUser, deleteAjUser,
    getDepartmentList, getAjRoleList, getAjCourseClassListOperation,
    updateAjUserPwAdmin, updateAjUserCheckLeave
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            tableHeight: null,
            accList: [],
            RoleList: [],
            addDialogVisible: false,
            editDialogVisible: false,
            resetPwdDialogVisible: false,
            checkLeaveDialogVisible: false,
            checkLeaveForm: {
                auId: '',
                auCheckLeave: 1,
                auCheckIdcard: ''
            },
            resetPwdForm: {
                auId: '',
                auPw: ''
            },
            form: {},
            formConfig: [],
            totalCount: 0,
            tableData: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, fixed: 'left', align: 'center' },
                { label: '姓名', prop: 'auName', width: 120, align: 'center', fixed: 'left' },
                { label: '岗位', prop: 'auPostName', width: 120, align: 'center' },
                { label: '账号', prop: 'auAccount', width: 150, align: 'center' },
                { label: '角色', prop: 'auRoleNames', align: 'center' },
                { label: '课程分类', prop: 'accNames', align: 'center' },
                { label: '邮箱', prop: 'auEmail', width: 180, align: 'center' },
                { label: '头像', prop: 'auHeader', width: 100, align: 'center' },
                { label: '是否校验在职', prop: 'auCheckLeave', width: 120, align: 'center' },
                { label: '审核状态', prop: 'auCheckStatus', width: 120, align: 'center' },
                { label: '身份证号', prop: 'auCheckIdcard', width: 180, align: 'center' },

                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 350,
                    buttons: [
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'checkLeave', text: '离职校验', icon: 'el-icon-check' },
                        { key: 'resetPwd', text: '重置密码', icon: 'el-icon-key', show: () => this.userInfo.auPost === 1 },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete', disabled: (row) => row.auId === 1 }
                    ]
                }
            ],
            tableEditable: false,

            formDatas: {
                auName: '',
                auAccount: '',
                auCheckLeave: '',
                auCheckStatus: '',
                currentPage: 1,
                pageSize: 20,
            },
            userInfo: {},
        };
    },


    created() {
        this.windheight = this.$store.state.windheight
        this.getUserInfo();
        this.partserch();
        getDepartmentList().then(res => {
            this.departmentList = res.data;
        })
        getAjRoleList().then(res => {
            this.RoleList = res.data;
        })
        getAjCourseClassListOperation({ accParentId: 0 }).then(res => {
            this.accList = res.data;
        })
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        getUserInfo() {
            this.userInfo = JSON.parse(localStorage.getItem('zhikeTong_userInfo') || '{}');
        },
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset: 120 });
            });
        },
        //
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该用户吗？',
                    type: 'success'
                })
                const newData = JSON.parse(JSON.stringify(data));
                newData.auHeader = data.auHeader.length > 0 ? data.auHeader[0] : '';
                newData.auRoleIds = data.auRoleIds.length > 0 ? JSON.stringify(data.auRoleIds) : '';
                newData.accIds = data.accIds.length > 0 ? JSON.stringify(data.accIds) : '';
                updateAjUser(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('编辑失败');
                    }
                })
            } catch {
                this.$message.error('取消');
            }
        },
        handleEditCancel({ type }) {
            console.log('编辑取消：', type);
        },
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            try {
                await this.$confirmDialog({
                    content: '确认新增该用户吗？',
                    type: 'success'
                })
                const newData = JSON.parse(JSON.stringify(data));
                newData.auHeader = data.auHeader.length > 0 ? data.auHeader[0] : '';
                newData.auRoleIds = data.auRoleIds.length > 0 ? JSON.stringify(data.auRoleIds) : '';
                newData.accIds = data.accIds.length > 0 ? JSON.stringify(data.accIds) : '';
                addAjUser(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('新增失败');
                    }
                })
            } catch {
                this.$message.error('取消');
            }
        },
        handleAddCancel({ type }) {
            console.log('新增取消：', type);
        },
        addForm() {
            this.getFormInit();
            this.addDialogVisible = true;
        },
        getFormInit() {
            this.formConfig = [
                [{
                    type: 'select', label: '部门', prop: 'adId', placeholder: '请选择部门', span: 24, required: true, options: [...this.departmentList], optionLabelKey: 'adName',
                    optionValueKey: 'adId',
                },],
                [{ type: 'input', label: '姓名', prop: 'auName', placeholder: '请输入姓名', span: 24, required: true, },],
                [{ type: 'input', label: '账号', prop: 'auAccount', placeholder: '请输入账号', span: 24, required: true },],
                [{ type: 'input', label: '邮箱', prop: 'auEmail', placeholder: '请输入邮箱', span: 24, required: false },],
                [{ type: 'input', label: '密码', prop: 'auPw', placeholder: '请输入密码', span: 24, required: false, showCondition: () => !this.editDialogVisible },],
                [{
                    type: 'upload', label: '头像', prop: 'auHeader', placeholder: '请选择头像', span: 24, required: false,
                    acceptType: 'image/*,application/pdf', limit: 1, multiple: false,
                }],
                [{
                    type: 'select', label: '岗位', prop: 'auPost', placeholder: '请选择岗位', span: 24, required: false, showCondition: () => !this.editDialogVisible,
                    options: [{ label: '系统管理员', value: 1 }, { label: '用户', value: 2 }, { label: '讲师管理员', value: 3 }, { label: '课程管理员', value: 4 }]
                }],
                [{
                    type: 'checkbox', label: '角色', prop: 'auRoleIds', placeholder: '请选择角色', span: 24, required: true, options: [...this.RoleList], optionLabelKey: 'roleName',
                    optionValueKey: 'roleId',
                }],
                [{
                    type: 'checkbox', label: '课程分类', prop: 'accIds', placeholder: '请选择分类', span: 24, required: false, options: [...this.accList], optionLabelKey: 'accName',
                    optionValueKey: 'accId',
                }],
                [{
                    type: 'radio', label: '校验在职', prop: 'auCheckLeave', span: 24, required: false,
                    options: [{ label: '否', value: 1 }, { label: '是', value: 2 }]
                }],
                [{ type: 'input', label: '身份证号', prop: 'auCheckIdcard', placeholder: '请输入身份证号', span: 24, required: false }],
            ];
            this.form = {
                auName: '',
                auAccount: '',
                auEmail: '',
                auPw: '',
                auHeader: [],
                auRoleIds: [],
                accIds: [],
                auCheckLeave: '',
                auCheckIdcard: '',
            };
        },
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            getAjUserList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'checkLeave':
                    this.handleCheckLeave(row);
                    break;
                case 'resetPwd':
                    this.handleResetPwd(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
            }
        },
        handleCheckLeave(row) {
            this.checkLeaveForm = {
                auId: row.auId,
                auCheckLeave: row.auCheckLeave || 1,
                auCheckIdcard: row.auCheckIdcard || ''
            };
            this.checkLeaveDialogVisible = true;
        },
        async handleCheckLeaveConfirm() {
            // 只有选择"是"时才校验身份证号
            if (this.checkLeaveForm.auCheckLeave == 2) {
                if (!this.checkLeaveForm.auCheckIdcard) {
                    this.$message.warning('请输入身份证号');
                    return;
                }
                const idcardPattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (!idcardPattern.test(this.checkLeaveForm.auCheckIdcard)) {
                    this.$message.warning('身份证号格式不正确');
                    return;
                }
            }
            try {
                await this.$confirmDialog({
                    content: '确认提交离职校验吗？',
                    type: 'success'
                });
                updateAjUserCheckLeave(this.checkLeaveForm).then(res => {
                    if (res.status === 200) {
                        this.$message.success('离职校验成功');
                        this.checkLeaveDialogVisible = false;
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '离职校验失败');
                    }
                });
            } catch {
                this.$message.info('取消提交');
            }
        },
        handleResetPwd(row) {
            this.resetPwdForm = {
                auId: row.auId,
                auPw: ''
            };
            this.resetPwdDialogVisible = true;
        },
        async handleResetPwdConfirm() {
            if (!this.resetPwdForm.auPw) {
                this.$message.warning('请输入新密码');
                return;
            }
            try {
                await this.$confirmDialog({
                    content: '确认重置该用户的密码吗？',
                    type: 'warning'
                });
                updateAjUserPwAdmin(this.resetPwdForm).then(res => {
                    if (res.status === 200) {
                        this.$message.success('密码重置成功');
                        this.resetPwdDialogVisible = false;
                    } else {
                        this.$message.error('密码重置失败');
                    }
                });
            } catch {
                this.$message.error('取消');
            }
        },
        handleSelectionChange(selRows) {
            console.log('当前页选中行：', selRows.map(row => row.id));
        },
        handleEdit(row) {
            this.getFormInit();
            const s = JSON.parse(JSON.stringify(row));
            s.auHeader = row.auHeader ? [row.auHeader] : [];
            s.auRoleIds = row.auRoleIds ? JSON.parse(row.auRoleIds) : [];
            s.accIds = row.accIds ? JSON.parse(row.accIds) : [];
            this.form = s;
            this.editDialogVisible = true;
        },
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该用户吗？',
                    type: 'danger'
                })
                deleteAjUser({ auId: row.auId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            } catch {
                this.$message.error('取消');
            }
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjUserList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        resetSearch() {
            this.formDatas.auName = '';
            this.formDatas.auAccount = '';
            this.formDatas.auCheckLeave = '';
            this.formDatas.auCheckStatus = '';
            this.partserch();
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    flex: 1;
    max-width: 200px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(245, 158, 11, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    /* display: grid; */
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
    flex-wrap: nowrap;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    flex-wrap: nowrap;
}

.card-title i {
    color: #f59e0b;
}

.card-actions {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #f8fafc;
    border-radius: 20px;
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #f59e0b;
    background: white;
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

/* Table Card */
.table-card {
    width: 100%;
    min-height: 400px;
}

.card-content {
    padding: 4px 0;
}

/* Avatar placeholder */
.no-avatar {
    color: #94a3b8;
    font-size: 12px;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}
</style>
